import { FC } from 'react';

export const FontColorIcon: FC = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M6 18L11.5 4H12.5L18 18H16L14.6 14H9.4L8 18H6ZM10 12H14L12 7L10 12Z" fill="currentColor" />
    <rect x="5" y="20" width="14" height="2" rx="1" fill="currentColor" />
  </svg>
);
